import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Authenticated API (uses HTTP-only cookies for admin auth)
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Public API without credentials — required so pre-rendering (react-snap on
// localhost) and any static host can call public GET endpoints across origins.
export const publicApi = axios.create({
  baseURL: API,
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
